import { useState } from "react";
import VentaTableUI from "../components/VentasTableUI";

const URL = process.env.REACT_APP_API_URL;

export default function VentaTable({
  headerData,
  bodyData,
  setBodyData,
  onSelect,
  selectedRows,
  setSelectedRows,
  isDeleteMode,
  isUpdateMode,
  filters,
}) {
  const [openProductsModal, setOpenProductsModal] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedSubtotal, setSelectedSubtotal] = useState(0);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(0);

  const showCheckbox = isDeleteMode || isUpdateMode;

  const handleSelectRow = (rowId) => {
    let newSelected;

    if (isUpdateMode) {
      newSelected = selectedRows.includes(rowId) ? [] : [rowId];
    } else {
      newSelected = selectedRows.includes(rowId)
        ? selectedRows.filter((id) => id !== rowId)
        : [...selectedRows, rowId];
    }
    setSelectedRows(newSelected);
    onSelect(newSelected);
  };

  const handlePay = async (saleId) => {
    try {
      // Llamar a la API para actualizar el estado de pago
      const response = await fetch(`${URL}/api/sales/${saleId}/isPaid/`, {
        method: "PUT",
      });

      if (!response.ok) throw new Error("Error al actualizar isPaid");

      // Actualizar el estado en el frontend
      setBodyData((prevData) =>
        prevData.map((sale) =>
          sale.id === saleId ? { ...sale, isPaid: !sale.isPaid } : sale
        )
      );
    } catch (error) {
      console.error("Error al actualizar la venta:", error);
    }
  };

  const handleOpenProductsModal = (products, subtotal) => {
    setSelectedProducts(products);
    setSelectedSubtotal(subtotal);
    setOpenProductsModal(true);
  };

  const handleCloseProductsModal = () => {
    setSelectedProducts([]);
    setOpenProductsModal(false);
  };

  const handleOpenPaymentModal = (payments, discount) => {
    setSelectedPayments(payments);
    setSelectedDiscount(discount);
    setOpenPaymentModal(true);
  };
  
  const handleClosePaymentModal = () => {
    setSelectedPayments([]);
    setOpenPaymentModal(false);
  };

  return (
    <VentaTableUI
      headerData={headerData}
      bodyData={bodyData}
      selectedRows={selectedRows}
      filters={filters}
      showCheckbox={showCheckbox}
      handleSelectRow={handleSelectRow}
      handlePay={handlePay}
      openProductsModal={openProductsModal}
      selectedProducts={selectedProducts}
      selectedSubtotal={selectedSubtotal}
      handleOpenProductsModal={handleOpenProductsModal}
      handleCloseProductsModal={handleCloseProductsModal}
      openPaymentModal={openPaymentModal}
      selectedPayments={selectedPayments}
      selectedDiscount={selectedDiscount}
      handleOpenPaymentModal={handleOpenPaymentModal}
      handleClosePaymentModal={handleClosePaymentModal}
    />
  );
}
